<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div class="header">
  <span class="heading">Select variant and quantity:</span>
</div>
<div class="size-quantity-wrapper">
  <div *ngFor="let item of inventoryItems">
    <app-size-quantity
      [isPriceDisplay]="isPriceDisplay"
      [isWishList]="isWishList"
      [isCart]="isCart"
      [val]="item.sizeValue ? item.sizeValue : 0"
      [item]="item"
      (updateQuantity)="updateQuantity($event)"
    ></app-size-quantity>
  </div>
</div>
<button (click)="OnAddClicked()" class="ws-add-btn ws-outline-none">ADD</button>
